module.exports = __webpack_public_path__ + "media/dashboard/assets/images/contact-socials/instagram-f5f1c354c17edf7d4e1fcfe0b50a1fb3.svg";